import { Link } from 'react-router';

import { ROUTES } from '@/shared/config';
import { RADIUS, Squircle } from '@/shared/ui';

import styles from './RewardsPromo.module.scss';

/** «Награды» на главном экране (узел 438:48313). */
export function RewardsPromo() {
  return (
    <Squircle cornerRadius={RADIUS.xl} className={styles.root}>
      <div className={styles.wedgeBox}>
        <img className={styles.wedge} src="/images/rewards/wedge-blue.svg" alt="" aria-hidden />
      </div>

      <h2 className={styles.title}>Награды</h2>

      <div className={styles.art}>
        <img className={styles.artImage} src="/images/rewards/trophy-ball.webp" alt="" aria-hidden />
      </div>

      <p className={styles.text}>
        Выполняй задания
        <br />
        и получай награды. Они помогут продвинуться
        <br />
        в рейтинге
      </p>

      <Squircle asChild cornerRadius={RADIUS.xl}>
        <Link className={styles.cta} to={ROUTES.career} data-testid="rewards-promo-cta">
          К Карьере
        </Link>
      </Squircle>
    </Squircle>
  );
}
